<div  >
  <mat-list>

    <mat-list-item [ngClass]="{'active' : (currentPath=='/dashboard'  ), 'tab': true}  " [routerLink]="['dashboard' ] " style="outline:none !important;">
      <mat-icon matListIcon>home</mat-icon>
       <p matLine class="demo-2">Dashboard</p>
    </mat-list-item>
    <mat-list-item [ngClass]="{'active' : (currentPath=='/active-quote' ), 'tab': true}" [routerLink]="['active-quote' ]" style="outline:none !important;">
      <mat-icon matListIcon>price_check</mat-icon>
      <p matLine class="demo-2">Active Quote</p>
    </mat-list-item>
    <mat-list-item [ngClass]="{'active' : (currentPath=='/preferred-pricing' ), 'tab': true}" [routerLink]="['preferred-pricing' ]" style="outline:none !important;">
      <mat-icon matListIcon>price_check</mat-icon>
      <p matLine class="demo-2">Preferred Pricing</p>
    </mat-list-item>

    <mat-list-item [routerLink]="['account' ]" [ngClass]="{'active' : (currentPath=='/account' ), 'tab': true}" style="outline:none !important;">
      <mat-icon matListIcon>account_box</mat-icon>
      <p matLine class="demo-2">Account</p>
    </mat-list-item>
  </mat-list>
</div>
